import React from "react";
import { Check } from "lucide-react";

export const TrustList = ({ items, columns = 2, testId = "trust-list" }) => {
  const gridCls =
    columns === 1
      ? "grid grid-cols-1"
      : columns === 3
      ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
      : "grid grid-cols-1 sm:grid-cols-2";
  return (
    <ul className={`${gridCls} gap-3`} data-testid={testId}>
      {items.map((t, i) => (
        <li
          key={i}
          className="flex items-start gap-2.5 text-sm sm:text-base text-brand-navy"
        >
          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-whatsapp/15">
            <Check className="h-3.5 w-3.5 text-brand-whatsapp-dark" strokeWidth={3} />
          </span>
          <span className="font-medium">{t}</span>
        </li>
      ))}
    </ul>
  );
};
